import styled from 'styled-components'
import { paddings } from '@/common/spacing'
import { colors } from '@/common/colors'

export const pillTextColors = {
  green: colors.greenDark,
  orange: colors.orangeDark,
  blue: colors.blueDark,
  red: colors.redDark,
  grey: colors.greyDark,
}

export const pillBackgroundColors = {
  green: colors.greenLight,
  orange: colors.orangeLight,
  blue: colors.blueLight,
  red: colors.redLight,
  grey: colors.greyscale6,
}

const Wrapper = styled.div<{ $color: keyof typeof pillTextColors }>`
  color: ${({ $color }) => pillTextColors[$color]};
  background-color: ${({ $color }) => pillBackgroundColors[$color]};
  width: auto;
  padding: 0 ${paddings.s};
  border: 1px solid ${({ $color }) => pillBackgroundColors[$color]};
  border-radius: 30px;
  height: auto;
  text-align: center;
  font-size: 12px;
  vertical-align: middle;
  display: inline-block;
  font-weight: normal;
`

export interface PillProps {
  color: keyof typeof pillTextColors
  children: React.ReactNode
}

export const Pill = ({ color, children }: PillProps) => (
  <Wrapper $color={color}>{children}</Wrapper>
)
